/*
 * Solarway: Infinite-Scroll für Collection-Pages.
 * Lädt die nächste Pagination-Seite per AJAX (Full-Page-Fetch + DOMParser für maximale Theme-Kompatibilität),
 * hängt die <li>-Karten ans Grid an und blendet die klassische Pagination-UI aus.
 * Re-initialisiert sich, wenn collection-filters.js das Grid nach einer Filteränderung austauscht.
 */
(function () {
  'use strict';

  var DEBUG = true; // Console-Logs während Stabilisierungsphase

  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, ['[InfiniteScroll]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  var STATE = {
    grid: null,
    nextUrl: null,
    hasMore: true,
    isLoading: false,
    loader: null,
    scrollHandler: null,
  };

  function getNextUrl(root) {
    root = root || document;
    // 1. Theme-spezifische Konvention: pagination.liquid setzt .pagination__item--prev auf den NEXT-Link
    var nextLink = root.querySelector('.pagination__item--prev[href], a.pagination__item-arrow[href][aria-label*="ext"], a.pagination__item-arrow[href][aria-label*="eiter"]');
    if (nextLink && nextLink.getAttribute('href')) {
      try {
        return new URL(nextLink.getAttribute('href'), window.location.origin).toString();
      } catch (e) { /* fall through */ }
    }
    // 2. Generischer Fallback: höchste page=N-Zahl in allen Pagination-Links
    var links = root.querySelectorAll('.pagination a[href*="page="], .pagination__item[href*="page="]');
    var maxPage = 0;
    var maxUrl = null;
    links.forEach(function (a) {
      var m = (a.getAttribute('href') || '').match(/[?&]page=(\d+)/);
      if (m) {
        var p = parseInt(m[1], 10);
        if (p > maxPage) {
          maxPage = p;
          maxUrl = a.getAttribute('href');
        }
      }
    });
    if (maxUrl) {
      try {
        // Aktuelle Page ermitteln
        var currentPage = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
        if (maxPage > currentPage) {
          // Direkter Next = currentPage + 1
          var u = new URL(maxUrl, window.location.origin);
          u.searchParams.set('page', currentPage + 1);
          return u.toString();
        }
      } catch (e) { /* */ }
    }
    return null;
  }

  function hidePagination() {
    document.querySelectorAll('.pagination-wrapper').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function ensureLoaderStyles() {
    if (document.getElementById('infinite-scroll-styles')) return;
    var style = document.createElement('style');
    style.id = 'infinite-scroll-styles';
    style.textContent =
      '.infinite-scroll-loader{text-align:center;padding:24px 16px;font-size:14px;color:#14192699;display:none;}' +
      '.infinite-scroll-loader.is-loading{display:block;}' +
      '.infinite-scroll-loader__spinner{display:inline-block;width:20px;height:20px;border:2px solid #46D377;border-top-color:transparent;border-radius:50%;animation:isLoaderSpin .8s linear infinite;vertical-align:middle;margin-right:8px;}' +
      '.infinite-scroll-sentinel{height:1px;width:100%;}' +
      '@keyframes isLoaderSpin{to{transform:rotate(360deg);}}';
    document.head.appendChild(style);
  }

  function createLoader() {
    // Loader wird unter dem Grid (statt unter .collection) eingehängt — robuster gegen Theme/App-DOM-Eingriffe
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.parentNode) return;

    STATE.loader = document.createElement('div');
    STATE.loader.className = 'infinite-scroll-loader';
    STATE.loader.innerHTML = '<span class="infinite-scroll-loader__spinner"></span>Lade weitere Produkte&hellip;';
    grid.parentNode.insertBefore(STATE.loader, grid.nextSibling);
  }

  function detachScrollHandler() {
    if (STATE.scrollHandler) {
      window.removeEventListener('scroll', STATE.scrollHandler);
      STATE.scrollHandler = null;
    }
  }

  function teardown() {
    detachScrollHandler();
    if (STATE.loader && STATE.loader.parentNode) STATE.loader.parentNode.removeChild(STATE.loader);
    STATE.loader = null;
    STATE.grid = null;
    STATE.nextUrl = null;
    STATE.hasMore = true;
    STATE.isLoading = false;
  }

  async function loadMore() {
    if (STATE.isLoading || !STATE.hasMore || !STATE.nextUrl) return;
    STATE.isLoading = true;
    if (STATE.loader) STATE.loader.classList.add('is-loading');
    log('loadMore →', STATE.nextUrl);

    try {
      var response = await fetch(STATE.nextUrl, { headers: { 'Accept': 'text/html' } });
      if (!response.ok) throw new Error('HTTP ' + response.status);

      var html = await response.text();
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      var newItems = doc.querySelectorAll('#product-grid > li');
      log('fetched items:', newItems.length);
      if (!newItems.length) {
        STATE.hasMore = false;
        disconnectObserver();
        return;
      }

      var grid = document.getElementById('product-grid');
      if (!grid) {
        STATE.hasMore = false;
        disconnectObserver();
        return;
      }

      newItems.forEach(function (li) {
        grid.appendChild(li);
      });

      var newNext = getNextUrl(doc);
      log('next URL after this batch:', newNext);
      STATE.nextUrl = newNext;
      if (!STATE.nextUrl) {
        STATE.hasMore = false;
        disconnectObserver();
      }

      // Browser-URL leise updaten
      try {
        var fetchedUrl = new URL(response.url || STATE.nextUrl || window.location.href, window.location.origin);
        var fetchedPage = fetchedUrl.searchParams.get('page');
        if (fetchedPage) {
          var visited = new URL(window.location.href);
          visited.searchParams.set('page', fetchedPage);
          window.history.replaceState({}, '', visited.toString());
        }
      } catch (e) {}
    } catch (err) {
      console.error('[InfiniteScroll] load error', err);
    } finally {
      STATE.isLoading = false;
      if (STATE.loader) STATE.loader.classList.remove('is-loading');
    }
  }

  function init() {
    teardown();

    var grid = document.getElementById('product-grid');
    if (!grid) {
      log('no #product-grid found, abort');
      return;
    }

    STATE.grid = grid;
    STATE.nextUrl = getNextUrl(document);

    log('init: nextUrl =', STATE.nextUrl);

    if (!STATE.nextUrl) {
      log('no next URL — likely single-page collection, no infinite scroll');
      return;
    }

    ensureLoaderStyles();
    hidePagination();
    createLoader();

    // Scroll-Listener — feuert wenn User dem unteren Rand des Produkt-Grids näher als 800px kommt.
    // Wichtig: NICHT am Document-Ende messen, weil unter .collection oft weitere Sections folgen
    // (related products, footer) — Trigger würde dann erst am Page-Boden feuern.
    var ticking = false;
    STATE.scrollHandler = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (STATE.isLoading || !STATE.hasMore) return;
        var grid = document.getElementById('product-grid');
        if (!grid) return;
        var rect = grid.getBoundingClientRect();
        // rect.bottom = Abstand vom Viewport-Top zum Grid-Bottom (kann negativ sein wenn schon gescrollt)
        // Trigger wenn Grid-Bottom innerhalb von 800px UNTERHALB der Viewport-Bottom ist
        if (rect.bottom <= window.innerHeight + 800) {
          log('near grid bottom (rect.bottom=' + Math.round(rect.bottom) + ', viewport=' + window.innerHeight + '), loadMore()');
          loadMore();
        }
      });
    };
    window.addEventListener('scroll', STATE.scrollHandler, { passive: true });
    // Einmal initial triggern (falls Seite kurz ist + nextUrl existiert)
    setTimeout(STATE.scrollHandler, 500);
    log('scroll listener attached');
  }

  function watchForGridReplacement() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    var debounceTimer;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var currentGrid = document.getElementById('product-grid');
        if (currentGrid && currentGrid !== STATE.grid) {
          log('grid replaced — re-init');
          init();
        }
      }, 250);
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  function start() {
    init();
    watchForGridReplacement();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
